import { memoize } from '@sama/micro-dash';
import { AttributeType } from '../../../team-apis/otterdam/taxonomy';
import { AttributeHelper } from './attribute-helper';
import { BooleanAttributeHelper } from './boolean-attribute-helper';
import { DynamicListAttributeHelper } from './dynamic-list-attribute-helper';
import { MultipleChoiceAttributeHelper } from './multiple-choice-attribute-helper';
import { SelectionFromListAttributeHelper } from './selection-from-list-attribute-helper';
import { SingleChoiceAttributeHelper } from './single-choice-attribute-helper';
import { TextAttributeHelper } from './text-attribute-helper';

export const getAttributeHelper = memoize(
  // eslint-disable-next-line complexity -- complexity is acceptable here, we are just handling each different attribute type
  (attributeType: AttributeType): AttributeHelper => {
    switch (attributeType) {
      case 'multiple_choice_attribute':
        return new MultipleChoiceAttributeHelper();
      case 'single_choice_attribute':
        return new SingleChoiceAttributeHelper();
      case 'boolean_attribute':
        return new BooleanAttributeHelper();
      case 'text_attribute':
        return new TextAttributeHelper();
      case 'dynamic_list_attribute':
        return new DynamicListAttributeHelper();
      case 'single_selection_from_dynamic_list_attribute':
        return new SelectionFromListAttributeHelper();
      default:
        throw new Error(`Unknown attribute type: ${attributeType}`);
    }
  },
);
